import React from "react";
import { Check, CreditCard, ShoppingBag, Plane, MapPin, Truck, PartyPopper } from "lucide-react";
import { STATUS_LABELS } from "../lib/format";

const STEPS = [
  { key: "PAYMENT_COMPLETED", icon: CreditCard },
  { key: "ITEM_PURCHASED", icon: ShoppingBag },
  { key: "TRAVELING", icon: Plane },
  { key: "ARRIVED", icon: MapPin },
  { key: "LOCAL_DELIVERY", icon: Truck },
  { key: "COMPLETED", icon: PartyPopper },
];

export default function OrderTimeline({ status }) {
  const idx = STEPS.findIndex((s) => s.key === status);
  const currentIdx = idx === -1 ? (["DISPUTED", "REFUNDED", "CANCELLED"].includes(status) ? 0 : 0) : idx;
  return (
    <div className="space-y-0" data-testid="order-timeline">
      {STEPS.map((step, i) => {
        const done = i < currentIdx;
        const active = i === currentIdx;
        const Icon = step.icon;
        return (
          <div key={step.key} className="flex gap-3">
            <div className="flex flex-col items-center">
              <div className={`w-9 h-9 rounded-full flex items-center justify-center transition-colors ${
                done ? "bg-lime text-navy" : active ? "bg-navy text-white" : "bg-white border border-black/10 text-muted-foreground"}`}>
                {done ? <Check size={16} strokeWidth={3} /> : <Icon size={16} />}
              </div>
              {i < STEPS.length - 1 && (
                <div className={`w-0.5 flex-1 min-h-[24px] ${i < currentIdx ? "bg-lime" : "bg-black/10"}`} />
              )}
            </div>
            <div className={`pb-6 ${active ? "font-bold text-navy" : done ? "text-ink" : "text-muted-foreground"}`}>
              <div className="text-sm mt-1.5">{STATUS_LABELS[step.key]}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
